import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Icon } from '@salesforce/design-system-react';

import './InfoCard.scss';

class InfoCard extends Component {
  render() {
    const { formatMessage } = this.props.intl;
    const {
      headingStringId,
      descriptionStringId,
      helpLinkTextId,
      iconName,
      link
    } = this.props;

    const icon = (
      <Icon
        assistiveText={{ label: iconName }}
        category="utility"
        name={iconName}
        size="medium"
      />
    );

    return (
      <div className="setup-info-card slds-card-wrapper slds-grid slds-grid_vertical-align-center">
        <div className="info-card-icon slds-col">{icon}</div>
        <div className="info-card-text">
          <h2 className="info-card-heading">
            <FormattedMessage id={headingStringId} />
          </h2>
          <p className="info-card-description">
            <FormattedMessage
              id={descriptionStringId}
              values={{
                link: (
                  <a rel="noopener noreferrer" target="_blank" href={link}>
                    {formatMessage({
                      id: helpLinkTextId
                    })}
                  </a>
                )
              }}
            />
          </p>
        </div>
      </div>
    );
  }
}

InfoCard.propTypes = {
  headingStringId: PropTypes.string,
  descriptionStringId: PropTypes.string,
  helpLinkTextId: PropTypes.string,
  iconName: PropTypes.node,
  link: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(InfoCard);
